export const DRIZZLE_INITIALIZED = 'DRIZZLE_INITIALIZED'
export const DRIZZLE_INITIALIZING = 'DRIZZLE_INITIALIZING'
export const DRIZZLE_FAILED = 'DRIZZLE_FAILED'
